import { render, staticRenderFns } from "./B2CUX.vue?vue&type=template&id=64edcf95"
import script from "./B2CUX.vue?vue&type=script&lang=js"
export * from "./B2CUX.vue?vue&type=script&lang=js"
import style0 from "./B2CUX.vue?vue&type=style&index=0&id=64edcf95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports